import {
    type FC
} from "react";
import {
    View
} from "react-native";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import type {
    ItemPartContentProps,
    IItemActionsProps
} from "../../type";
import {
    withItemContext
} from "../../context";
import stylesheet from "../../stylesheet";

const ItemActionsBase: FC<ItemPartContentProps<IItemActionsProps>> = ({
    customTheme: customThemeProp,
    children,
    context,
    style,
    ...props
}) => {
    const {
        spaces
    } = NCoreUIKitTheme.useContext(customThemeProp ?? context.customTheme);

    return <View
        {...props}
        style={[
            style,
            stylesheet.actions,
            {
                gap: spaces.spacingSm
            }
        ]}
    >
        {children}
    </View>;
};
export default withItemContext("actions", ItemActionsBase);
